import { OrdersFormViewModel } from '@ail/orders-api'

export function LogisticIdsView(props: { forms: OrdersFormViewModel[] }) {
  return (
    <table border={1}>
      <tbody>
        <tr>
          <th>Create Logistic Id</th>
        </tr>
        {props.forms.map((form) => (
          <tr key={form.id}>
            <td>{JSON.stringify(form.createLogisticId)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
